import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE = "https://hidani.online";

interface SeoProps {
  title: string;
  description: string;
  type?: "website" | "article";
  image?: string;
}

export const Seo = ({ title, description, type = "website", image }: SeoProps) => {
  const { pathname } = useLocation();
  const url = `${SITE}${pathname}`;
  const img = image ?? `${SITE}/hai-coin.png`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={img} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};

export default Seo;
